import { useStaticQuery, graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import styled from 'styled-components';

import BannerBackground from '../common/BannerBackground';
import Button from '../common/ui/Button';
import CtaLink from '../common/ui/CtaLink';

const Banner = () => {
  const data = useStaticQuery(graphql`
    query {
      image: file(relativePath: { eq: "home/banner.png" }) {
        ...bannerImageFragment
      }
    }
  `);

  return (
    <BannerBackground>
      <Wrapper>
        <ContentWrapper>
          <Subtitle>The modern commerce platform for wineries</Subtitle>
          <Title>Create better shopping experiences</Title>
          <Actions>
            <DemoButton to="/demo" variant="blue">
              Get Started
            </DemoButton>
            <CtaLink to="/signup/demo" color="white">
              Try for Free
            </CtaLink>
          </Actions>
        </ContentWrapper>
        <ImageWrapper>
          <GatsbyImage
            image={data.image.childImageSharp.gatsbyImageData}
            alt="A screenshot of Commerce7 platform."
          />
        </ImageWrapper>
      </Wrapper>
    </BannerBackground>
  );
};

const Wrapper = styled.div`
  ${({ theme }) => `
  @media ${theme.xLargeUp} {
      display: flex;
      align-items: center;
  }
`}
`;

const ContentWrapper = styled.div`
  margin-bottom: 60px;
  ${({ theme }) => `
    @media ${theme.xLargeUp} {
      margin-bottom: 0px;
      width: 54%;
    }
  `}
`;

const ImageWrapper = styled.div`
  width: 100%;
  max-width: 800px;
  margin: auto;
  ${({ theme }) => `
  @media ${theme.xLargeUp} {
      margin: 0;
      width: 46%;
    }
  `}
`;

const Title = styled.h1`
  color: var(--white);
  font-size: var(--heading-size-xl);
  font-weight: var(--font-weight-black);
  line-height: var(--line-height-sm);
  margin-bottom: 60px;
  max-width: 870px;
  ${({ theme }) => `
    @media ${theme.largeUp} {
      font-size: var(--heading-size-3xl);
    }
  `}
`;

const Subtitle = styled.p`
  color: rgba(255, 255, 255, 0.8);
  font-size: var(--heading-size-xs);

  margin-bottom: 12px;
`;

const Actions = styled.div`
  margin-bottom: 70px;
  display: block;
  ${({ theme }) => `
  @media ${theme.mediumUp} {
    display: flex;
    align-items: center;
    margin-bottom: 0;
  }
`}
`;

const DemoButton = styled(Button)`
  margin-right: 30px;
  margin-bottom: 20px;
  ${({ theme }) => `
    @media ${theme.mediumUp} {
    margin-bottom: 0px;
    }
  `}
`;

export default Banner;
